import classNames from "classnames";
import React from "react";

let statuses = [
  { label: "Submitted", key: "Submitted" },
  { label: "Scheduled", key: "Scheduled" },
  { label: "En Route", key: "En Route" },
  { label: "On Hold", key: "On Hold" },
  { label: "In Progress", key: "In Progress" },
  { label: "Resolved", key: "Resolved" },
  { label: "Declined", key: "Declined" },
  { label: "Closed", key: "Closed" },
  { label: "Archive", key: "Archive" },
  { label: "Assigned", key: "Assigned" },
  { label: "Under Review", key: "Under Review" },
  { label: "Approved", key: "Approved" },
  { label: "One Year Warranty", key: "One Year Warranty" },
];

export const BulkUpdateServiceRequest = ({
  disableBulkUpdate,
  onChangeStatus,
  style
}) => {
  return (
    <div className="bulkUpdateServReq" style={style}>
      <select
        className={classNames("select__bulkUpdate_options", {
          "select__bulkUpdate_options--background": !disableBulkUpdate,
        })}
        disabled={disableBulkUpdate}
        onChange={(e) => onChangeStatus(e.target.value)}
        value={""}
        style={{paddingLeft: "1rem", paddingRight: "1rem"}}
      >
        <option disabled="disabled" value="">BULK STATUS UPDATE</option>
        {statuses.map((stat, i) => (
          <option key={i} value={stat.label}>
            {stat.label}
          </option>
        ))}
      </select>
    </div>
  );
};
